import { BORDER_COLORS as BC, ICON_COLORS as IC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import type { AlertProps } from 'antd';
import { Alert } from 'antd';
import styled, { css } from 'styled-components';

const DESCRIPTION_NEGATIVE_SHIFT_ADJUSTMENT = -36;

const ALERT_STYLES = {
    default: css`
        background: #fff;
        border: 1px solid ${BC.default};

        span[role='img'] {
            color: ${IC.primary};
        }
    `,
    error: css`
        background: ${SC.error};
        border: 1px solid ${BC.error};

        span[role='img'] {
            color: ${IC.error};
        }
    `,
    success: css`
        background: ${SC.success};
        border: 1px solid ${BC.success};

        span[role='img'] {
            color: ${IC.success};
        }
    `,
    info: css`
        background: ${SC.information};
        border: 1px solid ${BC.secondary};

        span[role='img'] {
            color: ${IC.info};
        }
    `,
    warning: css`
        background: ${SC.warning};
        border: 1px solid ${BC.warning};

        span[role='img'] {
            color: ${IC.warning};
        }
    `,
};

const StyledAlertBanner = styled((props: AlertProps) => <Alert {...props} />)`
    &.ant-alert {
        color: ${TC.body};
        ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight}
        ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
        }

        span[role='img'].anticon-close {
            color: ${IC.primary};
        }

        .ant-alert-message {
            ${DESKTOP_SIZES[SIZES.BODY_MD].fontSize}
            ${DESKTOP_SIZES[SIZES.HEADING_MD].fontWeight}
            color: ${TC.heading};
            ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
            ${FONT_FAMILY.poppins};
        }

        .ant-alert-description {
            ${FONT_FAMILY.poppins};
            margin-left: ${({ title }) => (title ? DESCRIPTION_NEGATIVE_SHIFT_ADJUSTMENT : 0)}px;
        }
    }
    &.ant-alert-error {
        ${ALERT_STYLES.error}
    }
    &.ant-alert-success {
        ${ALERT_STYLES.success}
    }
    &.ant-alert-info {
        ${ALERT_STYLES.info}
    }
    &.ant-alert-warning {
        ${ALERT_STYLES.warning}
    }
    &.default {
        ${ALERT_STYLES.default}
    }
`;

interface AbsoluteWrapperProps {
    $width?: string;
}

export const AbsoluteWrapper = styled.div<AbsoluteWrapperProps>`
    .ant-alert {
        position: absolute;
        z-index: 3;
        right: 24px;
        width: ${({ $width }) => $width || 'auto'};
        top: 24px;
    }
`;

export default StyledAlertBanner;
